<template>
  <th
      v-if="showComponent"
      :title="qaAble ? showIfHasPermission?.toString() : title"
      v-show="!isHidden"
      :key="componentRefresh"
      :class="[showViewportClass]"
      :width="width"
      style="background: white; z-index: 2"
  >
    <div class="d-flex flex-row" v-if="!hasDefaultSlot">
      <span v-if="iconClass" @click="selected" :class="[{'pointer': clickable}]"><i :class="iconClass"></i></span>
      <span v-if="label" @click="selected" :class="[{'pointer': clickable}]"> {{ label }} </span>
      <div v-if="isSortable" style="padding-left: 7px;" class="pointer" @click="sort">
        <div v-show="sortType==null">
          <i class="fa fa-sort" aria-hidden="true" style="color: #b6c5d2;"></i>
        </div>
        <div v-show="sortType!==null">
          <span v-show="sortType === 'ASC'"><i class="fa fa-caret-up"></i></span>
          <span v-show="sortType === 'DESC'"><i class="fa fa-caret-down"></i></span>
        </div>
      </div>
      <!-- <div v-if="hidable" style="padding-left: 7px;" class="pointer" @click.prevent="hidden">
        <span><i class="fa fa-eye-slash" aria-hidden="true" style="color: #b6c5d2;"></i></span>
      </div> -->
    </div>
    <div style="background: white;" v-else>
      <slot></slot>
    </div>
  </th>
</template>

<script>
import checkPermissions from '../../../../mixins/checkPermissions';
import showViewport from '../../../../mixins/showViewport'

export default {
  name: 'ks-list-table-header',
  mixins: [showViewport, checkPermissions],
  props: {
    width: {type: String, default: null},
    label: {type: String, default: null},
    iconClass: {type: String, default: null},
    sortable: {type: Boolean, default: true},
    hiddenable: {type: Boolean, default: true},
    clickable: {type: Boolean, default: false},
    dataSource: {type: String, default: null},
    title: {type: String, default: null},
    defaultHidden: {type: Boolean, default: false},
  },
  watch: {
    orderBy(val, oldVal) {
      if (val === null) {
        this.sortType = null;
      } else {
        this.setSortTypeByOrderBy();
      }
    },
    '$parent.columns': {
      handler(columns) {
        this.isHidden = false;
        for (let column in columns) {
          if (column === this.dataSource) {
            this.isHidden = columns[column].isHidden;
          }
        }
      },
      deep: true
    }
  },
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default;
    },
    orderBy() {
      return this.$parent.data_provider_ref.l_orderBy;
    },
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  },
  methods: {
    selected() {
      this.$parent.columnHeaderEvent('selected', this);
    },
    sort() {
      if (this.isSortable) {
        this.sortType = this.sortType == null ? 'DESC' : this.sortType === 'ASC' ? 'DESC' : 'ASC';
        this.$parent.columnHeaderEvent('sort', this);
      }
    },
    hidden() {
      this.isHidden = !this.isHidden;
      this.$parent.columnHeaderEvent('hidden', this);
    },
    getComponentConfiguration() {
      return {
        sortType: this.sortType,
        isSortable: this.isSortable,
        isHidden: this.isHidden
      }
    },
    setSortTypeByOrderBy() {
      let orderByArray = this.orderBy ? this.orderBy.split(',') : [];
      if (orderByArray.length > 0) {
        let defaultSort = orderByArray.find(e => e.split(" ")[0].toLowerCase().trim() == this.dataSource.toLowerCase().trim());
        if (defaultSort) {
          this.sortType = defaultSort.split(" ")[1].toUpperCase().trim();
          return;
        }
      }
      this.sortType = null;
    },
    setComponentConfiguration(dataSource, config, _default = false) {
      if (_default) {
        this.sortType = null,
            this.isHidden = this.defaultHidden,
            this.isSortable = this.sortable == true && this.dataSource !== null ? true : false;
      } else {
        if (dataSource === this.dataSource) {
          for (let prop in config) {
            this[prop] = config[prop];
          }
        }
      }
    }
  },
  mounted() {
    if (this.dataSource) {
      this.setSortTypeByOrderBy();
      this.$set(this.$parent.columns, this.dataSource, {
        'label': this.label,
        'title': this.title,
        'iconClass': this.iconClass,
        'dataSource': this.dataSource,
        'hiddenable': this.hiddenable,
        ...this.getComponentConfiguration()
      })
    }
  },
  data() {
    return {
      sortType: null,
      isHidden: this.defaultHidden,
      isSortable: this.sortable == true && this.dataSource !== null ? true : false,
    }
  }
}
</script>
